import { mutator } from 'satcheljs';
import { onResize } from '../actions/internalActions';
import getScenarioStore from '../selectors/getScenarioStore';

mutator(onResize, actionMessage => {
    const { scenarioId, searchBoxWidth } = actionMessage;
    getScenarioStore(scenarioId).searchBoxWidth = searchBoxWidth;
});
